module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Regular-25e40da956314b12d333fe72cc420957.ttf";